import { createFileRoute } from '@tanstack/react-router';
import { validateBookingSearch } from '@/features/online-booking/nav-ids';
import { OnlineBookingPage } from '@/features/online-booking/pages/online-booking-page';

export const Route = createFileRoute('/_app/settings/online-booking')({
  validateSearch: validateBookingSearch,
  component: BookingTab,
});

function BookingTab() {
  const { step } = Route.useSearch();
  return <OnlineBookingPage step={step} />;
}
